import { DriverApiFactory } from "./../data/service-proxies/api";
import { useAxiosInstance, useAxiosBaseURL } from "./useAxiosInstance";
import { Identifier } from "react-admin";
import { useEffect, useState } from "react";
import { DriverDto } from "../data/service-proxies";

const isNumber = (id: Identifier): id is number => {
  return typeof id === "number";
};

export const useDriver = (id?: Identifier) => {
  const axios = useAxiosInstance();
  const baseURL = useAxiosBaseURL();
  const [driver, setDriver] = useState<DriverDto>();
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    if (!axios) {
      return;
    }

    if (!baseURL) {
      return;
    }

    if (!id) {
      return;
    }

    let driverId: number;
    if (!isNumber(id)) {
      driverId = parseInt(id);
    } else {
      driverId = id;
    }

    if (isNaN(driverId)) {
      return;
    }

    setLoading(true);
    DriverApiFactory(undefined, baseURL, axios)
      .apiAppDriverIdGet(driverId)
      .then((response) => {
        setDriver(response.data);
      })
      .catch((err) => console.warn("useDriver failed: ", err))
      .finally(() => setLoading(false));
  }, [axios, baseURL, id]);

  return { driver, loading };
};
